// extracted by mini-css-extract-plugin
export var subMenuMobileView = "style-module--sub-menu-mobile-view--828e4";
export var subMenuMobileView__contentSection = "style-module--sub-menu-mobile-view__contentSection--ba4d1";
export var subMenuMobileView__ctaSection = "style-module--sub-menu-mobile-view__ctaSection--d4e57";